import React,{Component} from 'react';
import Swiper from 'swiper';

function swiperInit(){
    const galleryTop = new Swiper('.gallery-top', {
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
    const galleryThumbs = new Swiper('.gallery-thumbs', {
        centeredSlides: true,
        slidesPerView: 5,
        touchRatio: 0.2,
        slideToClickedSlide: true,
    });
    galleryTop.controller.control = galleryThumbs;
    galleryThumbs.controller.control = galleryTop;
}

export default class SwiperBox extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
        swiperInit()
    }
    render(){
        const {isSellout,selectedColor} = this.props;
        const liList = [];
        for(let i=1;i<6;i++){
            liList.push(<li className="swiper-slide" key={i}><img src={`/images/purchase/products/pic_${selectedColor}_${i}.jpg?20190617`} alt="" /></li>)
        }
        return <div className="np-buy-feature">
            <div className="np-feature-big">
                <div className="swiper-container gallery-top swiper-container-horizontal">
                    <ul className="swiper-wrapper">
                        {liList}
                    </ul>
                    <div className="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>
                </div>
                {   isSellout &&
                    <div className="np-feature-none">
                    <div className="np-feature-none-tb">
                        <p>已抢完</p>
                        <a href="#">了解更多 &gt;</a>
                    </div>
                </div>
                }
            </div>
            <div className="np-feature-bullet">
                <div className="swiper-container gallery-thumbs swiper-container-horizontal">
                    <ul className="swiper-wrapper">
                        {liList}
                    </ul>
                </div>
            </div>
        </div>
    }
}
SwiperBox.defaultProps = {
    isSellout: false,
    selectedColor: 'orange'
}


// WEBPACK FOOTER //
// ./js/src/pages/Purchase/components/swiperbox.jsx